export default "__VITE_ASSET__xVWNQ1hn__"